export const Tutorial = [
  // 0
  [
    { type: 'emoji', content: '🤖' },
    { type: 'text', content: 'Beep-Boop' },
    { type: 'emoji', content: '🤖' },
    { type: 'text', content: "Ruby API Simulator ready... Get the full code at the end of this tutorial. You'll be done in a couple of minutes." },
    { type: 'text', content: 'You have been assigned an ' },
    { type: 'code', content: 'account_id' },
    { type: 'text', content: 'and' },
    { type: 'code', content: 'contact_id' },
    { type: 'text', content: 'below.' },
    { type: 'pre', content: 'account_id = 123\ncontact_id = 456' },
    { type: 'break', content: '' },
    { type: 'text', content: "First, let's check for domains in your account. For this we use the" },
    { type: 'code', content: 'domains' },
    { type: 'text', content: 'namespace' },
    { type: 'pre', content: 'dnsimple.domains.list_domains(account_id)' },
    { type: 'button', content: 'Try Me' }
  ],
  // 1
  [
    { type: 'result', content: '#<Dnsimple::PaginatedResponse>' },
    { type: 'emoji', content: '👍' },
    { type: 'text', content: 'You got a structure back! Call ' },
    { type: 'code', content: 'data' },
    { type: 'text', content: 'to explore the structure and iterate over it.' },
    { type: 'pre', content: 'dnsimple.domains.list_domains(account_id).data.each do |domain|\n  puts domain.name\nend' },
    { type: 'button', content: 'Run' }
  ],
  // 2
  [
    { type: 'result', content: 'dnsimple.com\nhowhttps.works' },
    { type: 'emoji', content: '👀' },
    { type: 'text', content: "You have 2 domains in your account. Let's register a new domain. With our API, you can check if the domain is available before you register it. Let's say you want to register " },
    { type: 'code', content: 'apijoy.dev' },
    { type: 'text', content: '. Check for the availability of this domain:' },
    { type: 'pre', content: 'dnsimple.registrar.check_domain(account_id, "apijoy.dev").data' },
    { type: 'button', content: 'Run' }
  ],
  // 3
  [
    { type: 'result', content: '#<Dnsimple::Struct::DomainCheck @domain="apijoy.dev", @available=true, @premium=false>' },
    { type: 'emoji', content: '✅' },
    { type: 'text', content: 'Check the ' },
    { type: 'code', content: 'available' },
    { type: 'text', content: 'attribute on the response to see if the domain can be registered. The response says ' },
    { type: 'code', content: 'available = true' },
    { type: 'text', content: "Let's register this domain now:" },
    { type: 'pre', content: 'dnsimple.registrar.register_domain(\n  account_id, \n  "apijoy.dev", \n  registrant_id: contact_id\n).data' },
    { type: 'button', content: 'Run' }
  ],
  // 4
  [
    { type: 'result', content: '#<Dnsimple::Struct::DomainRegistration @state="registered", @auto_renew=false, @whois_privacy=false @period=1 @id=1234, @domain_id=12345, @registrant_id=1234>' },
    { type: 'emoji', content: '🙌' },
    { type: 'text', content: 'The domain is now registered and in your account!' },
    { type: 'text', content: "Time to configure the DNS. Point the root of this domain to a CNAME like resource. For this, we'll use the ALIAS record." },
    { type: 'pre', content: 'dnsimple.zones.create_zone_record(\n  account_id,\n  "apijoy.dev",\n  name: ""  # Name is blank for records on the root domain\n  type: "alias",\n  content: "root-domain-magic.herokudns.com"\n)' },
    { type: 'button', content: 'Run' }
  ],
  // 5
  [
    { type: 'result', content: '#<Dnsimple::Struct::ZoneRecord @id=12345, @zone_id="apijoy.dev", @parent_id=nil, @name="", @content="root-domain-magic.herokudns.com", @ttl=3600, @type="ALIAS", @regions=["global"], @system_record=false>' },
    { type: 'emoji', content: '💾' },
    { type: 'text', content: "The record was created and will start responding to DNS queries within seconds. Our last task is to get an TLS/SSL certificate for this domain. Let's order a Let's Encrypt certificate:" },
    { type: 'pre', content: 'ssl_order = dnsimple.certificates.purchase_letsencrypt_certificate(\n  account_id,\n  "apijoy.dev",\n  contact_id: contact_id\n)' },
    { type: 'button', content: 'Run' }
  ],
  // 6
  [
    { type: 'result', content: '#<Dnsimple::Struct::CertificatePurchase @id=123, @certificate_id=456, @state="new", @auto_renew=false ...>' },
    { type: 'emoji', content: '🔒' },
    { type: 'text', content: 'Perfect! The certificate has been ordered. We just need to issue it now using the' },
    { type: 'code', content: 'id' },
    { type: 'text', content: 'provided in the response.' },
    { type: 'pre', content: 'dnsimple.certificates.issue_letsencrypt_certificate(\n  account_id,\n  "apijoy.dev",\n  ssl_order.data.id\n)' },
    { type: 'button', content: 'Run' }
  ],
  // 7
  [
    { type: 'result', content: '#<Dnsimple::Struct::Certificate @common_name="www.apijoy.dev", @years=1, @csr=nil, @state="requesting">' },
    { type: 'emoji', content: '🕐' },
    { type: 'text', content: 'This is an async process. We just have to wait for a few minutes for the certificate to be issued. Once this is done, downloading it is easy.' },
    { type: 'pre', content: 'dnsimple.certificates.download_certificate(\n  account_id,\n  "apijoy.dev",\n  ssl_order.data.id\n)' },
    { type: 'emoji', content: '👏' },
    { type: 'text', content: 'Thank you for getting this far. You have reached the end of this introduction to our Ruby API. I hope you have enjoyed it, and we cannot wait to see what you build with it!' },
    { type: 'break', content: '' },
    { type: 'break', content: '' },
    { type: 'show', content: 'Get the complete code from this tutorial' }
  ]
];
